import * as actions from './currentUiSettingsActionTypes';


export const setCsOverviewSearchCustomer = csOverviewSearchCustomer => ({
    type: actions.CS_OVERVIEW_SEARCH_CUSTOMER,
    csOverviewSearchCustomer
})

export const setCsOverviewSearchSupplier = csOverviewSearchSupplier => ({
    type: actions.CS_OVERVIEW_SEARCH_SUPPLIER,
    csOverviewSearchSupplier
})

export const setCsOverviewSearchContact = csOverviewSearchContact => ({
    type: actions.CS_OVERVIEW_SEARCH_CONTACT,
    csOverviewSearchContact
})

export const setCsOverviewSearchMember = csOverviewSearchMember => ({
    type: actions.CS_OVERVIEW_SEARCH_MEMBER,
    csOverviewSearchMember
})

export const setCsOverviewSearchActive = csOverviewSearchActive => ({
    type: actions.CS_OVERVIEW_SEARCH_ACTIVE,
    csOverviewSearchActive
})

export const setCsOverviewSearchInactive = csOverviewSearchInactive => ({
    type: actions.CS_OVERVIEW_SEARCH_INACTIVE,
    csOverviewSearchInactive
})

export const setCsOverviewSearchTerm = csOverviewSearchTerm => ({
    type: actions.CS_OVERVIEW_SEARCH_TERM,
    csOverviewSearchTerm
})

export const setCsOverviewSearchKeywords = csOverviewSearchKeywords => ({
    type: actions.CS_OVERVIEW_SEARCH_KEYWORDS,
    csOverviewSearchKeywords
})

export const setCsExportFilterOpen = csExportFilterOpen => ({
    type: actions.CS_EXPORT_FILTER_OPEN,
    csExportFilterOpen
})

export const setCsExportExportOpen = csExportExportOpen => ({
    type: actions.CS_EXPORT_EXPORT_OPEN,
    csExportExportOpen
})

export const setCsExportSearchCustomer = csExportSearchCustomer => ({
    type: actions.CS_EXPORT_SEARCH_CUSTOMER,
    csExportSearchCustomer
})

export const setCsExportSearchSupplier = csExportSearchSupplier => ({
    type: actions.CS_EXPORT_SEARCH_SUPPLIER,
    csExportSearchSupplier
})

export const setCsExportSearchContact = csExportSearchContact => ({
    type: actions.CS_EXPORT_SEARCH_CONTACT,
    csExportSearchContact
})

export const setCsExportSearchMember = csExportSearchMember => ({
    type: actions.CS_EXPORT_SEARCH_MEMBER,
    csExportSearchMember
})

export const setCsExportSearchActive = csExportSearchActive => ({
    type: actions.CS_EXPORT_SEARCH_ACTIVE,
    csExportSearchActive
})

export const setCsExportSearchInactive = csExportSearchInactive => ({
    type: actions.CS_EXPORT_SEARCH_INACTIVE,
    csExportSearchInactive
})

export const setCsExportSearchTerm = csExportSearchTerm => ({
    type: actions.CS_EXPORT_SEARCH_TERM,
    csExportSearchTerm
})

export const setCsExportSearchKeywords = csExportSearchKeywords => ({
    type: actions.CS_EXPORT_SEARCH_KEYWORDS,
    csExportSearchKeywords
})

export const setCsExportIncludeBasedata = csExportIncludeBasedata => ({
    type: actions.CS_EXPORT_INCLUDE_BASEDATA,
    csExportIncludeBasedata
})

export const setCsExportIncludeGeneral = csExportIncludeGeneral => ({
    type: actions.CS_EXPORT_INCLUDE_GENERAL,
    csExportIncludeGeneral
})

export const setCsExportIncludeAddress = csExportIncludeAddress => ({
    type: actions.CS_EXPORT_INCLUDE_ADDRESS,
    csExportIncludeAddress
})

export const setCsExportIncludeContact = csExportIncludeContact => ({
    type: actions.CS_EXPORT_INCLUDE_CONTACT,
    csExportIncludeContact
})

export const setCsExportIncludeContactPerson = csExportIncludeContactPerson => ({
    type: actions.CS_EXPORT_INCLUDE_CONTACT_PERSON,
    csExportIncludeContactPerson
})

export const setCsExportIncludeBilling = csExportIncludeBilling => ({
    type: actions.CS_EXPORT_INCLUDE_BILLING,
    csExportIncludeBilling
})

export const setCsExportIncludeMember = csExportIncludeMember => ({
    type: actions.CS_EXPORT_INCLUDE_MEMBER,
    csExportIncludeMember
})

export const setCsExportIncludePostalAddress = csExportIncludePostalAddress => ({
    type: actions.CS_EXPORT_INCLUDE_POSTAL_ADDRESS,
    csExportIncludePostalAddress
})

export const setCsExportIncludeUserAdministration = csExportIncludeUserAdministration => ({
    type: actions.CS_EXPORT_INCLUDE_USER_ADMINISTRATION,
    csExportIncludeUserAdministration
})

export const setCsExportIncludeNotice = csExportIncludeNotice => ({
    type: actions.CS_EXPORT_INCLUDE_NOTICE,
    csExportIncludeNotice
})

export const setInvoiveMembershipFilterOpen = invoiveMembershipFilterOpen => ({
    type: actions.INVOIVE_MEMBERSHIP_FILTER_OPEN,
    invoiveMembershipFilterOpen
})

export const setInvoiveMembershipStarting = invoiveMembershipStarting => ({
    type: actions.INVOIVE_MEMBERSHIP_STARTING,
    invoiveMembershipStarting
})

export const setInvoiveMembershipEnding = invoiveMembershipEnding => ({
    type: actions.INVOIVE_MEMBERSHIP_ENDING,
    invoiveMembershipEnding
})

export const setInvoiveMembershipCategories = invoiveMembershipCategories => ({
    type: actions.INVOIVE_MEMBERSHIP_CATEGORIES,
    invoiveMembershipCategories
})

export const setInvoiceOverviewFilterOpen = invoiceOverviewFilterOpen => ({
    type: actions.INVOICE_OVERVIEW_FILTER_OPEN,
    invoiceOverviewFilterOpen
})

export const setInvoiceOverviewInvoiceStatus = invoiceOverviewInvoiceStatus => ({
    type: actions.INVOICE_OVERVIEW_INVOICE_STATUS,
    invoiceOverviewInvoiceStatus
})

export const setInvoiceOverviewAccountingStatus = invoiceOverviewAccountingStatus => ({
    type: actions.INVOICE_OVERVIEW_ACCOUNTING_STATUS,
    invoiceOverviewAccountingStatus
})

export const setInvoiceOverviewSearchTerm = invoiceOverviewSearchTerm => ({
    type: actions.INVOICE_OVERVIEW_SEARCH_TERM,
    invoiceOverviewSearchTerm
})

export const setInvoiceOverviewStarting = invoiceOverviewStarting => ({
    type: actions.INVOICE_OVERVIEW_STARTING,
    invoiceOverviewStarting
})

export const setInvoiceOverviewEnding = invoiceOverviewEnding => ({
    type: actions.INVOICE_OVERVIEW_ENDING,
    invoiceOverviewEnding
})

export const setInvoiceOverviewRegister = invoiceOverviewRegister => ({
    type: actions.INVOICE_OVERVIEW_REGISTER,
    invoiceOverviewRegister
})

export const setInvoiceOverviewYear = invoiceOverviewYear => ({
    type: actions.INVOICE_OVERVIEW_YEAR,
    invoiceOverviewYear
})

export const setInvoiceOverviewStartNumber = invoiceOverviewStartNumber => ({
    type: actions.INVOICE_OVERVIEW_START_NUMBER,
    invoiceOverviewStartNumber
})

export const setInvoiceOverviewEndNumber = invoiceOverviewEndNumber => ({
    type: actions.INVOICE_OVERVIEW_END_NUMBER,
    invoiceOverviewEndNumber
})

export const setInvoiceOverviewSepa = invoiceOverviewSepa => ({
    type: actions.INVOICE_OVERVIEW_SEPA,
    invoiceOverviewSepa
})

export const setBudgetForecastSelectedYear = budgetForecastSelectedYear => ({
    type: actions.BUDGET_FORECAST_SELECTED_YEAR,
    budgetForecastSelectedYear
})


export const setBudgetForecastSumAutoWidth = budgetForecastSumAutoWidth => ({
    type: actions.BUDGET_FORECAST_SUM_AUTO_WIDTH,
    budgetForecastSumAutoWidth
})
export const setBudgetForecastSumAutoExpandAll = budgetForecastSumAutoExpandAll => ({
    type: actions.BUDGET_FORECAST_SUM_AUTO_EXPAND_ALL,
    budgetForecastSumAutoExpandAll
})
export const setBudgetForecastSumSelectedMonthOption = budgetForecastSumSelectMonthOption => ({
    type: actions.BUDGET_FORECAST_SUM_SELECT_MONTH_OPTION,
    budgetForecastSumSelectMonthOption
})


export const setBudgetForecastSumShowMonthlyDifference = budgetForecastSumShowMonthlyDifference => ({
    type: actions.BUDGET_FORECAST_SUM_SHOW_MONTHLY_DIFFERENCE,
    budgetForecastSumShowMonthlyDifference
})


export const setBudgetForecastSumShowAnnotation = budgetForecastSumShowAnnotation => ({
    type: actions.BUDGET_FORECAST_SUM_SHOW_ANNOTATION,
    budgetForecastSumShowAnnotation
})
export const setBudgetForecastSumShowYears = budgetForecastSumShowYears => ({
    type: actions.BUDGET_FORECAST_SUM_SHOW_YEAR,
    budgetForecastSumShowYears
})
export const setBudgetForecastSumCharts = budgetForecastSumCharts => ({
    type: actions.BUDGET_FORECAST_SUM_CHARTS,
    budgetForecastSumCharts
})

export const setBudgetForecastShowSummary = budgetForecastShowSummary => ({
    type: actions.BUDGET_FORECAST_SHOW_SUMMARY,
    budgetForecastShowSummary
})


export const setBudgetForecastShowYearToDate = budgetForecastShowYearToDate => ({
    type: actions.BUDGET_FORECAST_SHOW_YEAR_TO_DATE,
    budgetForecastShowYearToDate
})

export const setBudgetForecastShowForecast = budgetForecastShowForecast => ({
    type: actions.BUDGET_FORECAST_SHOW_FORECAST,
    budgetForecastShowForecast
})


export const setBudgetForecastOverviewActive = budgetForecastOverviewActive => ({
    type: actions.BUDGET_FORECAST_OVERVIEW_ACTIVE,
    budgetForecastOverviewActive
})

export const setBudgetForecastOverviewInactive = budgetForecastOverviewInactive => ({
    type: actions.BUDGET_FORECAST_OVERVIEW_INACTIVE,
    budgetForecastOverviewInactive
})

export const setBudgetForecastOverviewSearchTerm = budgetForecastOverviewSearchTerm => ({
    type: actions.BUDGET_FORECAST_OVERVIEW_SEARCH_TERM,
    budgetForecastOverviewSearchTerm
})


export const setBudgetDetailConfigCollapsed = budgetDetailConfigCollapsed => ({
    type: actions.BUDGET_DETAIL_CONFIG_COLLAPSED,
    budgetDetailConfigCollapsed
})

export const setBudgetDetailNoteFieldCollapsed = budgetDetailNoteFieldCollapsed => ({
    type: actions.BUDGET_DETAIL_NOTE_FIELD_COLLAPSED,
    budgetDetailNoteFieldCollapsed
})

export const setBudgetDetailSingleMonthDetailsCollapsed = budgetDetailSingleMonthDetailsCollapsed => ({
    type: actions.BUDGET_DETAIL_SINGLE_MONTH_DETAILS_COLLAPSED,
    budgetDetailSingleMonthDetailsCollapsed
})




export const setTodoSettingsNotificationGroupListActiveFilter = todoSettingsNotificationGroupListActiveFilter => ({
    type: actions.TODO_SETTINGS_NOTIFICATION_GROUP_LIST_ACTIVE_FILTER,
    todoSettingsNotificationGroupListActiveFilter
})

export const setTodoSettingsNotificationGroupListInactiveFilter = todoSettingsNotificationGroupListInactiveFilter => ({
    type: actions.TODO_SETTINGS_NOTIFICATION_GROUP_LIST_INACTIVE_FILTER,
    todoSettingsNotificationGroupListInactiveFilter
})


export const setTodoSettingsNotificationTypeListActiveFilter = todoSettingsNotificationTypeListActiveFilter => ({
    type: actions.TODO_SETTINGS_NOTIFICATION_TYPE_LIST_ACTIVE_FILTER,
    todoSettingsNotificationTypeListActiveFilter
})

export const setTodoSettingsNotificationTypeListInactiveFilter = todoSettingsNotificationTypeListInactiveFilter => ({
    type: actions.TODO_SETTINGS_NOTIFICATION_TYPE_LIST_INACTIVE_FILTER,
    todoSettingsNotificationTypeListInactiveFilter
})


export const setTodoSettingsNotificationStateListActiveFilter = todoSettingsNotificationStateListActiveFilter => ({
    type: actions.TODO_SETTINGS_NOTIFICATION_STATE_LIST_ACTIVE_FILTER,
    todoSettingsNotificationStateListActiveFilter
})

export const setTodoSettingsNotificationStateListInactiveFilter = todoSettingsNotificationStateListInactiveFilter => ({
    type: actions.TODO_SETTINGS_NOTIFICATION_STATE_LIST_INACTIVE_FILTER,
    todoSettingsNotificationStateListInactiveFilter
})

///


export const setParishMassTypesListActiveFilter = parishMassTypesListActiveFilter => ({
    type: actions.PARISH_MASS_TYPES_LIST_ACTIVE_FILTER,
    parishMassTypesListActiveFilter
})


export const setParishMassTypesListInactiveFilter = parishMassTypesListInactiveFilter => ({
    type: actions.PARISH_MASS_TYPES_LIST_INACTIVE_FILTER,
    parishMassTypesListInactiveFilter
})


export const setParishIntentionTypesListActiveFilter = parishIntentionTypesListActiveFilter => ({
    type: actions.PARISH_INTENTION_TYPES_LIST_ACTIVE_FILTER,
    parishIntentionTypesListActiveFilter
})


export const setParishIntentionTypesListInactiveFilter = parishIntentionTypesListInactiveFilter => ({
    type: actions.PARISH_INTENTION_TYPES_LIST_INACTIVE_FILTER,
    parishIntentionTypesListInactiveFilter
})

///

export const setEmpSettingsTimeModelActiveFilter = empSettingsTimeModelActiveFilter => ({
    type: actions.EMP_SETTINGS_TIME_MODEL_ACTIVE_FILTER,
    empSettingsTimeModelActiveFilter
})

export const setEmpSettingsTimeModelInactiveFilter = empSettingsTimeModelInactiveFilter => ({
    type: actions.EMP_SETTINGS_TIME_MODEL_INACTIVE_FILTER,
    empSettingsTimeModelInactiveFilter
})


export const setEmpSettingsDayPlanActiveFilter = empSettingsDayPlanActiveFilter => ({
    type: actions.EMP_SETTINGS_DAY_PLAN_ACTIVE_FILTER,
    empSettingsDayPlanActiveFilter
})

export const setEmpSettingsDayPlanInactiveFilter = empSettingsDayPlanInactiveFilter => ({
    type: actions.EMP_SETTINGS_DAY_PLAN_INACTIVE_FILTER,
    empSettingsDayPlanInactiveFilter
})


export const setEmpSettingsFlexActiveFilter = empSettingsFlexActiveFilter => ({
    type: actions.EMP_SETTINGS_FLEX_ACTIVE_FILTER,
    empSettingsFlexActiveFilter
})

export const setEmpSettingsFlexInactiveFilter = empSettingsFlexInactiveFilter => ({
    type: actions.EMP_SETTINGS_FLEX_INACTIVE_FILTER,
    empSettingsFlexInactiveFilter
})




export const setTimeCalendarSearchMonth = timeCalendarSearchMonth => ({
    type: actions.TIME_CALENDAR_SEARCH_MONTH,
    timeCalendarSearchMonth
})

export const setTimeCalendarSearchGroup = timeCalendarSearchGroup => ({
    type: actions.TIME_CALENDAR_SEARCH_GROUP,
    timeCalendarSearchGroup
})

export const setTimeCalendarSearchEmployee = timeCalendarSearchEmployee => ({
    type: actions.TIME_CALENDAR_SEARCH_EMPLOYEE,
    timeCalendarSearchEmployee
})

export const setTimeCalendarSearchWork = timeCalendarSearchWork => ({
    type: actions.TIME_CALENDAR_SEARCH_WORK,
    timeCalendarSearchWork
})




export const setFraOverviewSearchActive = fraOverviewSearchActive => ({
    type: actions.FRA_OVERVIEW_SEARCH_ACTIVE,
    fraOverviewSearchActive
})

export const setFraOverviewSearchInactive = fraOverviewSearchInactive => ({
    type: actions.FRA_OVERVIEW_SEARCH_INACTIVE,
    fraOverviewSearchInactive
})

export const setFraOverviewSearchMember = fraOverviewSearchMember => ({
    type: actions.FRA_OVERVIEW_SEARCH_MEMBER,
    fraOverviewSearchMember
})

export const setFraOverviewSearchNotMember = fraOverviewSearchNotMember => ({
    type: actions.FRA_OVERVIEW_SEARCH_NOT_MEMBER,
    fraOverviewSearchNotMember
})

export const setFraOverviewSearchOrderByLveNumber = fraOverviewSearchOrderByLveNumber => ({
    type: actions.FRA_OVERVIEW_SEARCH_ORDER_BY_LVE_NUMBER,
    fraOverviewSearchOrderByLveNumber
})

export const setFraOverviewSearchTerm = fraOverviewSearchTerm => ({
    type: actions.FRA_OVERVIEW_SEARCH_TERM,
    fraOverviewSearchTerm
})



export const setFraMembershipOverviewSearchTerm = fraMembershipOverviewSearchTerm => ({
    type: actions.FRA_MEMBERSHIP_OVERVIEW_SEARCH_TERM,
    fraMembershipOverviewSearchTerm
})




export const setTreeConfigOverviewSearchActive = treeConfigOverviewSearchActive => ({
    type: actions.TREE_CONFIG_OVERVIEW_SEARCH_ACTIVE,
    treeConfigOverviewSearchActive
})

export const setTreeConfigOverviewSearchInactive = treeConfigOverviewSearchInactive => ({
    type: actions.TREE_CONFIG_OVERVIEW_SEARCH_INACTIVE,
    treeConfigOverviewSearchInactive
})
export const setTreeConfigOverviewSearchTemplate = treeConfigOverviewSearchTemplate => ({
    type: actions.TREE_CONFIG_OVERVIEW_SEARCH_TEMPLATE,
    treeConfigOverviewSearchTemplate
})

export const setTreeConfigOverviewSearchProduction = treeConfigOverviewSearchProduction => ({
    type: actions.TREE_CONFIG_OVERVIEW_SEARCH_PRODUCTION,
    treeConfigOverviewSearchProduction
})
export const setTreeConfigOverviewSearchTerm = treeConfigOverviewSearchTerm => ({
    type: actions.TREE_CONFIG_OVERVIEW_SEARCH_TERM,
    treeConfigOverviewSearchTerm
})


export const setTreeProjectOverviewSearchActive = treeProjectOverviewSearchActive => ({
    type: actions.TREE_PROJECT_OVERVIEW_SEARCH_ACTIVE,
    treeProjectOverviewSearchActive
})

export const setTreeProjectOverviewSearchInactive = treeProjectOverviewSearchInactive => ({
    type: actions.TREE_PROJECT_OVERVIEW_SEARCH_INACTIVE,
    treeProjectOverviewSearchInactive
})

export const setTreeProjectOverviewSearchTerm = treeProjectOverviewSearchTerm => ({
    type: actions.TREE_PROJECT_OVERVIEW_SEARCH_TERM,
    treeProjectOverviewSearchTerm
})

export const setTreeProjectOverviewSearchCs = treeProjectOverviewSearchCs => ({
    type: actions.TREE_PROJECT_OVERVIEW_SEARCH_CS,
    treeProjectOverviewSearchCs
})


export const setTodoOrderOverviewSearchActive = todoOrderOverviewSearchActive => ({
    type: actions.TODO_ORDER_OVERVIEW_SEARCH_ACTIVE,
    todoOrderOverviewSearchActive
})

export const setTodoOrderOverviewSearchInactive = todoOrderOverviewSearchInactive => ({
    type: actions.TODO_ORDER_OVERVIEW_SEARCH_INACTIVE,
    todoOrderOverviewSearchInactive
})

export const setTodoOrderOverviewSearchTerm = todoOrderOverviewSearchTerm => ({
    type: actions.TODO_ORDER_OVERVIEW_SEARCH_TERM,
    todoOrderOverviewSearchTerm
})

export const setTodoOrderOverviewSearchCs = todoOrderOverviewSearchCs => ({
    type: actions.TODO_ORDER_OVERVIEW_SEARCH_CS,
    todoOrderOverviewSearchCs
})

export const setTodoOrderOverviewSearchFra = todoOrderOverviewSearchFra => ({
    type: actions.TODO_ORDER_OVERVIEW_SEARCH_FRA,
    todoOrderOverviewSearchFra
})



export const setTreeProjectBranchListFilterName = treeProjectBranchListFilterName => ({
    type: actions.TREE_PROJECT_BRANCH_LIST_FILTER_NAME,
    treeProjectBranchListFilterName
})

export const setTreeProjectBranchListFilterType = treeProjectBranchListFilterType => ({
    type: actions.TREE_PROJECT_BRANCH_LIST_FILTER_TYPE,
    treeProjectBranchListFilterType
})

export const setTreeProjectBranchListFilterStatus = treeProjectBranchListFilterStatus => ({
    type: actions.TREE_PROJECT_BRANCH_LIST_FILTER_STATUS,
    treeProjectBranchListFilterStatus
})

export const setTreeProjectBranchListFilterShowDeleted = treeProjectBranchListFilterShowDeleted => ({
    type: actions.TREE_PROJECT_BRANCH_LIST_FILTER_SHOW_DELETED,
    treeProjectBranchListFilterShowDeleted
})


export const setTreeProjectCodeFilterVisibleStatus = treeProjectCodeFilterVisibleStatus => ({
    type: actions.TREE_PROJECT_CODE_FILTER_VISIBLE_STATUS,
    treeProjectCodeFilterVisibleStatus
})

/*
export const setTreeProjectBranchListFilterArchive = treeProjectBranchListFilterArchive => ({
    type: actions.TREE_PROJECT_BRANCH_LIST_FILTER_ARCHIVE,
    treeProjectBranchListFilterArchive
})
*/

export const setDataProjectItemListFilterSearchTerm = dataProjectItemListFilterSearchTerm => ({
    type: actions.DATA_PROJECT_ITEM_LIST_FILTER_SEARCH_TERM,
    dataProjectItemListFilterSearchTerm
})

export const setDataProjectItemListFilterIsQuarter1 = dataProjectItemListFilterIsQuarter1 => ({
    type: actions.DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER1,
    dataProjectItemListFilterIsQuarter1
})

export const setDataProjectItemListFilterIsQuarter2 = dataProjectItemListFilterIsQuarter2 => ({
    type: actions.DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER2,
    dataProjectItemListFilterIsQuarter2
})

export const setDataProjectItemListFilterIsQuarter3 = dataProjectItemListFilterIsQuarter3 => ({
    type: actions.DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER3,
    dataProjectItemListFilterIsQuarter3
})

export const setDataProjectItemListFilterIsQuarter4 = dataProjectItemListFilterIsQuarter4 => ({
    type: actions.DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER4,
    dataProjectItemListFilterIsQuarter4
})



export const setTodoItemListFilterStatuses = todoItemListFilterStatuses => ({
    type: actions.TODO_ITEM_LIST_FILTER_STATUSES,
    todoItemListFilterStatuses
})

export const setTodoItemListFilterTypes = todoItemListFilterTypes => ({
    type: actions.TODO_ITEM_LIST_FILTER_TYPES,
    todoItemListFilterTypes
})

export const setTodoItemListFilterStarting = todoItemListFilterStarting => ({
    type: actions.TODO_ITEM_LIST_FILTER_STARTING,
    todoItemListFilterStarting
})

export const setTodoItemListFilterEnding = todoItemListFilterEnding => ({
    type: actions.TODO_ITEM_LIST_FILTER_ENDING,
    todoItemListFilterEnding
})

export const setTodoItemListFilterCollapsed = todoItemListFilterCollapsed => ({
    type: actions.TODO_ITEM_LIST_FILTER_COLLAPSED,
    todoItemListFilterCollapsed
})



export const setDataProjectItemListFilterChangeStarting = dataProjectItemListFilterChangeStarting => ({
    type: actions.DATA_PROJECT_ITEM_LIST_FILTER_CHANGE_STARTING,
    dataProjectItemListFilterChangeStarting
})

export const setDataProjectItemListFilterChangeEnding = dataProjectItemListFilterChangeEnding => ({
    type: actions.DATA_PROJECT_ITEM_LIST_FILTER_CHANGE_ENDING,
    dataProjectItemListFilterChangeEnding
})

export const setDataProjectItemListFilterMultiSelectStatus = dataProjectItemListFilterMultiSelectStatus => ({
    type: actions.DATA_PROJECT_ITEM_LIST_FILTER_MULTI_SELECT_STATUS,
    dataProjectItemListFilterMultiSelectStatus
})





export const setDataProjectTreeFilterMultiSelectStatus = dataProjectTreeFilterMultiSelectStatus => ({
    type: actions.DATA_PROJECT_TREE_FILTER_MULTI_SELECT_STATUS,
    dataProjectTreeFilterMultiSelectStatus
})

export const setDataProjectTreeFilterMultiSelectTrafficLight = dataProjectTreeFilterMultiSelectTrafficLight => ({
    type: actions.DATA_PROJECT_TREE_FILTER_MULTI_SELECT_TRAFFICLIGHT,
    dataProjectTreeFilterMultiSelectTrafficLight
})


export const setDataProjectTreeFilterShowArchivedStatus = dataProjectTreeFilterShowArchivedStatus => ({
    type: actions.DATA_PROJECT_TREE_FILTER_SHOW_ARCHIVED_STATUS,
    dataProjectTreeFilterShowArchivedStatus
})


export const setDataProjectTreeBranchOnlyNotNull = dataProjectTreeBranchOnlyNotNull => ({
    type: actions.DATA_PROJECT_TREE_BRANCH_ONLY_NOT_NULL,
    dataProjectTreeBranchOnlyNotNull
})

export const setDataProjectTreeFilterCollapsed = dataProjectTreeFilterCollapsed => ({
    type: actions.DATA_PROJECT_TREE_FILTER_COLLAPSED,
    dataProjectTreeFilterCollapsed
})









export const setTreeProjectAutoHide = treeProjectAutoHide => ({
    type: actions.TREE_PROJECT_AUTO_HIDE,
    treeProjectAutoHide
})




export const setConvOverviewCheckboxOpen = convOverviewCheckboxOpen => ({
    type: actions.CONV_OVERVIEW_CHECKBOX_OPEN,
    convOverviewCheckboxOpen
})

export const setConvOverviewCheckboxElaboration = convOverviewCheckboxElaboration => ({
    type: actions.CONV_OVERVIEW_CHECKBOX_ELABORATION,
    convOverviewCheckboxElaboration
})

export const setConvOverviewCheckboxClose = convOverviewCheckboxClose => ({
    type: actions.CONV_OVERVIEW_CHECKBOX_CLOSE,
    convOverviewCheckboxClose
})

export const setConvOverviewCheckboxError = convOverviewCheckboxError => ({
    type: actions.CONV_OVERVIEW_CHECKBOX_ERROR,
    convOverviewCheckboxError
})

export const setConvOverviewCheckboxDeleteRequest = convOverviewCheckboxDeleteRequest => ({
    type: actions.CONV_OVERVIEW_CHECKBOX_DELETE_REQUEST,
    convOverviewCheckboxDeleteRequest
})

export const setConvOverviewCheckboxDeleted = convOverviewCheckboxDeleted => ({
    type: actions.CONV_OVERVIEW_CHECKBOX_DELETE,
    convOverviewCheckboxDeleted
})

export const setConvOverviewSearchTerm = convOverviewSearchTerm => ({
    type: actions.CONV_OVERVIEW_SEARCH_TERM,
    convOverviewSearchTerm
})





export const setEmpOverviewSearchActive = empOverviewSearchActive => ({
    type: actions.EMP_OVERVIEW_SEARCH_ACTIVE,
    empOverviewSearchActive
})

export const setEmpOverviewSearchInactive = empOverviewSearchInactive => ({
    type: actions.EMP_OVERVIEW_SEARCH_INACTIVE,
    empOverviewSearchInactive
})

export const setEmpOverviewSearchText = empOverviewSearchText => ({
    type: actions.EMP_OVERVIEW_SEARCH_TEXT,
    empOverviewSearchText
})


export const setTodoOverviewFilterOpen = todoOverviewFilterOpen => ({
    type: actions.TODO_OVERVIEW_FILTER_OPEN,
    todoOverviewFilterOpen
})


/*deprecated*/
export const setTodoOverviewAlertFilter = todoOverviewAlertFilter => ({
    type: actions.TODO_OVERVIEW_ALERT_FILTER,
    todoOverviewAlertFilter
})

/*deprecated*/
export const setTodoOverviewTaskFilter = todoOverviewTaskFilter => ({
    type: actions.TODO_OVERVIEW_TASK_FILTER,
    todoOverviewTaskFilter
})

/*deprecated*/
export const setTodoOverviewOtherFilter = todoOverviewOtherFilter => ({
    type: actions.TODO_OVERVIEW_OTHER_FILTER,
    todoOverviewOtherFilter
})


/*deprecated*/
export const setTodoOverviewCheckTodoFilter = todoOverviewCheckTodoFilter => ({
    type: actions.TODO_OVERVIEW_CHECK_TODO_FILTER,
    todoOverviewCheckTodoFilter
})

/*deprecated*/
export const setTodoOverviewCheckObjectFilter = todoOverviewCheckObjectFilter => ({
    type: actions.TODO_OVERVIEW_CHECK_OBJECT_FILTER,
    todoOverviewCheckObjectFilter
})





export const setTodoOverviewTextFilter = todoOverviewTextFilter => ({
    type: actions.TODO_OVERVIEW_TEXT_FILTER,
    todoOverviewTextFilter
})

export const setTodoOverviewEndingFilter = todoOverviewEndingFilter => ({
    type: actions.TODO_OVERVIEW_ENDING_FILTER,
    todoOverviewEndingFilter
})

export const setTodoOverviewStartingFilter = todoOverviewStartingFilter => ({
    type: actions.TODO_OVERVIEW_STARTING_FILTER,
    todoOverviewStartingFilter
})



/*deprecated*/
export const setTodoOverviewStartingObjectFilter = todoOverviewStartingObjectFilter => ({
    type: actions.TODO_OVERVIEW_STARTING_OBJECT_FILTER,
    todoOverviewStartingObjectFilter
})
/*deprecated*/
export const setTodoOverviewEndingObjectFilter = todoOverviewEndingObjectFilter => ({
    type: actions.TODO_OVERVIEW_ENDING_OBJECT_FILTER,
    todoOverviewEndingObjectFilter
})



export const setTodoOverviewStatusFilter = todoOverviewStatusFilter => ({
    type: actions.TODO_OVERVIEW_STATUS_FILTER,
    todoOverviewStatusFilter
})

export const setTodoOverviewShowNotAssignedFilter = todoOverviewShowNotAssignedFilter => ({
    type: actions.TODO_OVERVIEW_SHOW_NOT_ASSIGNED_FILTER,
    todoOverviewShowNotAssignedFilter
})


export const setTodoOverviewResponsible = todoOverviewResponsible => ({
    type: actions.TODO_OVERVIEW_RESPONSIBLE,
    todoOverviewResponsible
})

export const setTodoOverviewMonitoring = todoOverviewMonitoring => ({
    type: actions.TODO_OVERVIEW_MONITORING,
    todoOverviewMonitoring
})



export const setTodoOverviewFlag = todoOverviewFlag => ({
    type: actions.TODO_OVERVIEW_FLAG,
    todoOverviewFlag
})

export const setTodoOverviewPersonalFlag = todoOverviewPersonalFlag => ({
    type: actions.TODO_OVERVIEW_PERSONAL_FLAG,
    todoOverviewPersonalFlag
})





export const setTodoOverviewModuleFilter = todoOverviewModuleFilter => ({
    type: actions.TODO_OVERVIEW_MODULE_FILTER,
    todoOverviewModuleFilter
})

export const setTodoOverviewDetailTypeFilter = todoOverviewDetailTypeFilter => ({
    type: actions.TODO_OVERVIEW_DETAILTYPE_FILTER,
    todoOverviewDetailTypeFilter
})

export const setTodoOverviewProjectFilter = todoOverviewProjectFilter => ({
    type: actions.TODO_OVERVIEW_PROJECT_FILTER,
    todoOverviewProjectFilter
})

export const setTodoOverviewTodoFilter = todoOverviewTodoFilter => ({
    type: actions.TODO_OVERVIEW_TODO_FILTER,
    todoOverviewTodoFilter
})







export const setDataSearchCreatedFromFilter = dataSearchCreatedFromFilter => ({
    type: actions.DATA_SEARCH_CREATD_FROM_FILTER,
    dataSearchCreatedFromFilter
})

export const setDataSearchCreatedToFilter = dataSearchCreatedToFilter => ({
    type: actions.DATA_SEARCH_CREATED_TO_FILTER,
    dataSearchCreatedToFilter
})

export const setDataSearchValidFromFilter = dataSearchValidFromFilter => ({
    type: actions.DATA_SEARCH_VALID_FROM_FILTER,
    dataSearchValidFromFilter
})

export const setDataSearchValidToFilter = dataSearchValidToFilter => ({
    type: actions.DATA_SEARCH_VALID_TO_FILTER,
    dataSearchValidToFilter
})

export const setDataSearchStatusFilter = dataSearchStatusFilter => ({
    type: actions.DATA_SEARCH_STATUS_FILTER,
    dataSearchStatusFilter
})

export const setDataSearchModuleFilter = dataSearchModuleFilter => ({
    type: actions.DATA_SEARCH_MODULE_FILTER,
    dataSearchModuleFilter
})

export const setDataSearchKeywordList = dataSearchKeywordList => ({
    type: actions.DATA_SEARCH_KEYWORD_LIST,
    dataSearchKeywordList
})

export const setDataSearchDetailTypeFilter = dataSearchDetailTypeFilter => ({
    type: actions.DATA_SEARCH_DETAIL_TYPE_FILTER,
    dataSearchDetailTypeFilter
})

export const setDataSearchProjectFilter = dataSearchProjectFilter => ({
    type: actions.DATA_SEARCH_PROJECT_FILTER,
    dataSearchProjectFilter
})

export const setDataSearchTextFilter = dataSearchTextFilter => ({
    type: actions.DATA_SEARCH_TEXT_FILTER,
    dataSearchTextFilter
})


export const setDataSearchShowNotificationsFilter = dataSearchShowNotifications => ({
    type: actions.DATA_SEARCH_SHOW_NOTIFICATION_FILTER,
    dataSearchShowNotifications
})


export const setDataSearchOpenFilter = dataSearchOpenFilter => ({
    type: actions.DATA_SEARCH_OPEN_FILTER,
    dataSearchOpenFilter
})






export const setDistributionListsActive = distributionListsActive => ({
    type: actions.DISTRIBUTION_LISTS_ACTIVE,
    distributionListsActive
})

export const setDistributionListsInactive = distributionListsInactive => ({
    type: actions.DISTRIBUTION_LISTS_INACTIVE,
    distributionListsInactive
})

export const setDistributionListsSearchText = distributionListsSearchText => ({
    type: actions.DISTRIBUTION_LISTS_SEARCH_TEXT,
    distributionListsSearchText
})




export const setCommunicationOverviewFrom = communicationOverviewFrom => ({
    type: actions.COMMUNICATION_OVERVIEW_FROM,
    communicationOverviewFrom: communicationOverviewFrom
})

export const setCommunicationOverviewTo = communicationOverviewTo => ({
    type: actions.COMMUNICATION_OVERVIEW_TO,
    communicationOverviewTo: communicationOverviewTo
})

export const setCommunicationOverviewType = communicationOverviewType => ({
    type: actions.COMMUNICATION_OVERVIEW_TYPE,
    communicationOverviewType: communicationOverviewType
})

export const setCommunicationOverviewSearchText = communicationOverviewSearchText => ({
    type: actions.COMMUNICATION_OVERVIEW_SEARCH_TEXT,
    communicationOverviewSearchText: communicationOverviewSearchText
})

export const setCommunicationOverviewSearchVisibility = communicationOverviewSearchVisibility => ({
    type: actions.COMMUNICATION_OVERVIEW_SEARCH_VISIBILITY,
    communicationOverviewSearchVisibility
})




export const setCommunicationAdministrationSearchText = communicationAdministrationSearchText => ({
    type: actions.COMMUNICATION_ADMINISTRATION_SEARCH_TEXT,
    communicationAdministrationSearchText: communicationAdministrationSearchText
})

export const setCommunicationAdministrationActive = communicationAdministrationActive => ({
    type: actions.COMMUNICATION_ADMINISTRATION_ACTIVE,
    communicationAdministrationActive: communicationAdministrationActive
})

export const setCommunicationAdministrationInactive = communicationAdministrationInactive => ({
    type: actions.COMMUNICATION_ADMINISTRATION_INACTIVE,
    communicationAdministrationInactive: communicationAdministrationInactive
})

export const setCommunicationAdministrationFrom = communicationAdministrationFrom => ({
    type: actions.COMMUNICATION_ADMINISTRATION_FROM,
    communicationAdministrationFrom: communicationAdministrationFrom
})

export const setCommunicationAdministrationTo = communicationAdministrationTo => ({
    type: actions.COMMUNICATION_ADMINISTRATION_TO,
    communicationAdministrationTo: communicationAdministrationTo
})

export const setCommunicationAdministrationType = communicationAdministrationType => ({
    type: actions.COMMUNICATION_ADMINISTRATION_TYPE,
    communicationAdministrationType: communicationAdministrationType
})





export const setEmployeeHistoryMonth = employeeHistoryMonth => ({
    type: actions.EMPLOYEE_HISTORY_MONTH,
    employeeHistoryMonth
})

export const setEmployeeHistoryActive = employeeHistoryActive => ({
    type: actions.EMPLOYEE_HISTORY_ACTIVE,
    employeeHistoryActive
})

export const setEmployeeHistoryInactive = employeeHistoryInactive => ({
    type: actions.EMPLOYEE_HISTORY_INACTIVE,
    employeeHistoryInactive
})

export const setEmployeeHistoryTimeTrackingActive = employeeHistoryTimeTrackingActive => ({
    type: actions.EMPLOYEE_HISTORY_TIME_TRACKING_ACTIVE,
    employeeHistoryTimeTrackingActive
})

export const setEmployeeHistoryTimeTrackingInactive = employeeHistoryTimeTrackingInactive => ({
    type: actions.EMPLOYEE_HISTORY_TIME_TRACKING_INACTIVE,
    employeeHistoryTimeTrackingInactive
})




export const setTeamVacationOverviewColumnMode = teamVacationOverviewColumnMode => ({
    type: actions.TEAM_VACATION_OVERVIEW_COLUMN_MODE,
    teamVacationOverviewColumnMode
})








export const setTimeTrackCurrentListOrderByLastname = timeTrackCurrentListOrderByLastname => ({
    type: actions.TIME_TRACK_CURRENT_LIST_ORDER_BY_LASTNAME,
    timeTrackCurrentListOrderByLastname
})

export const setTimeTrackCurrentListCheckedIn = timeTrackCurrentListCheckedIn => ({
    type: actions.TIME_TRACK_CURRENT_LIST_CHECKED_IN,
    timeTrackCurrentListCheckedIn
})

export const setTimeTrackCurrentListCheckedOut = timeTrackCurrentListCheckedOut => ({
    type: actions.TIME_TRACK_CURRENT_LIST_CHECKED_OUT,
    timeTrackCurrentListCheckedOut
})

export const setTimeTrackCurrentListBreakTime = timeTrackCurrentListBreakTime => ({
    type: actions.TIME_TRACK_CURRENT_LIST_BREAK_TIME,
    timeTrackCurrentListBreakTime
})

export const setTimeTrackCurrentListSearchTerm = timeTrackCurrentListSearchTerm => ({
    type: actions.TIME_TRACK_CURRENT_LIST_SEARCH_TERM,
    timeTrackCurrentListSearchTerm
})

export const setTimeTrackCurrentListGroup = timeTrackCurrentListGroup => ({
    type: actions.TIME_TRACK_CURRENT_LIST_GROUP,
    timeTrackCurrentListGroup
})





export const setTimemanagerMonthDaySwitch = timemanagerMonthDaySwitch => ({
    type: actions.TIMEMANAGER_MONTH_DAY_SWITCH,
    timemanagerMonthDaySwitch
})

export const setTimemanagerDate = timemanagerDate => ({
    type: actions.TIMEMANAGER_DATE,
    timemanagerDate
})

export const setTimemanagerMonth = timemanagerMonth => ({
    type: actions.TIMEMANAGER_MONTH,
    timemanagerMonth
})

export const setTimemanagerEmployeeRid = timemanagerEmployeeRid => ({
    type: actions.TIMEMANAGER_EMPLOYEE_RID,
    timemanagerEmployeeRid
})



export const setTeamEndOfMonthOverviewSearchMonth = teamEndOfMonthOverviewMonth => ({
    type: actions.TEAM_END_OF_MONTH_OVERVIEW_MONTH,
    teamEndOfMonthOverviewMonth
})

export const setTeamEndOfMonthOverviewOpen = teamEndOfMonthOverviewOpen => ({
    type: actions.TEAM_END_OF_MONTH_OVERVIEW_OPEN,
    teamEndOfMonthOverviewOpen
})

export const setTeamEndOfMonthOverviewCloseByEmp = teamEndOfMonthOverviewCloseByEmp => ({
    type: actions.TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_EMP,
    teamEndOfMonthOverviewCloseByEmp
})

export const setTeamEndOfMonthOverviewCloseByTL = teamEndOfMonthOverviewCloseByTL => ({
    type: actions.TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_TL,
    teamEndOfMonthOverviewCloseByTL
})

export const setTeamEndOfMonthOverviewCloseByHR = teamEndOfMonthOverviewCloseByHR => ({
    type: actions.TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_HR,
    teamEndOfMonthOverviewCloseByHR
})

export const setTeamEndOfMonthOverviewSearchText = teamEndOfMonthOverviewTextFilter => ({
    type: actions.TEAM_END_OF_MONTH_OVERVIEW_TEXT_FILTER,
    teamEndOfMonthOverviewTextFilter
})



export const setMaxFileUploadSize = maxFileUploadSize => ({
    type: actions.MAX_FILE_UPLOAD_SIZE,
    maxFileUploadSize
})

export const setLeftSideMenuIsMinimized = leftSideMenuIsMinimized => ({
    type: actions.LEFT_SIDE_MENU_IS_MINIMIZED,
    leftSideMenuIsMinimized
})

export const setProgramVersion = programVersion => ({
    type: actions.PROGRAM_VERSION,
    programVersion
})

export const setSysTeamApi7Url = sysTeamApi7Url => ({
    type: actions.SYS_TEAMAPI7URL,
    sysTeamApi7Url
})